
import { GetUserStatsDocument, GetUserStatsQuery } from '@/graphql/queries/GetUserStats.query';
import { Component, ProvideReactive, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { captureMessageForSentry } from '@/helpers/sentry-helper';

/** Use this symbol to Inject and Provide user stats. */
export const UserStatsKey = Symbol('UsersStats');
/*********************/

export type UserStats = {
	maxCustomListsDefault: number;
	maxCustomListsPro: number;
};
/*********************/
const User = namespace('user');

@Component({
	name: 'UserStatsProvider',
	apollo: {
		userStats: {
			query: GetUserStatsDocument,
			skip() {
				// avoid errors when jwId is not present (seoUser)
				return !this.jwId;
			},
			update({ stats }: GetUserStatsQuery) {
				this.$store.dispatch('user/setPremiumStatus', stats.hasJWProSubscription);
				return stats || {};
			},
			errorPolicy: 'all',
			error(error) {
				captureMessageForSentry(
					'[GraphQL Get User Stats Data]:',
					{ error: error, where: 'Component: UserStatsProvider' },
					'error'
				);
			},
		},
	},
})
export default class UserStatsProvider extends Vue {
	@User.State jwId: string;

	@ProvideReactive(UserStatsKey)
	userStats: UserStats = {} as UserStats;

	render() {
		if (this.$scopedSlots.default) {
			return this.$scopedSlots.default({});
		}
		return this.$slots[0];
	}
}
